import React, { useState, useEffect } from 'react';

const IntruccionesSeleccionDeCamasV2 = (p) => {
    const valvula = p.valvula;
    const metros = p.metros;

    return (
        <>
            <div className='w-100 mt-3 mb-0 text-center text-300 h3'>
                Camas disponibles en la valvula <span className='text-bold ms-3 me-2'>{valvula.valvula}</span>-
                <span className='text-bold text-m me-2 ms-2'>Largo de cama: <span className='ms-1 text-400'>{valvula.largo_cama} mts</span></span>-
                <span className='text-bold text-m ms-2'>Metros necesarios: <span className='ms-1 text-400'>{metros}</span></span>
            </div>
            <div className='w-100 mb-3 mt-0 text-s text-justify'>
                <div className='w-100 text-bold text-m text-start mb-0'>Lo que representan los colores:</div>
                Cada cama tiene una línea de llenado. Cuando esta es blanca, se encuentra desocupada. Cuando es de color ámbar significa que la cama está parcialmente ocupada. De color negro está completamente ocupada. De color rojo significa que se llenó con más del 100% de su capacidad.
                <div className='w-100 text-bold text-m text-start mt-1 mb-0'>Cómo seleccionar camas:</div>
                Pulse sobre la cama que desea elegir, después pulse sobre el recuadro "Cama inicio" o "Cama fin" para que el sistema le asigne la cama que eligió.
                <div className='w-100 text-bold text-m text-start mt-1 mb-0'>Tenga en cuenta:</div>
                Esta nueva versión le permite seleccionar camas ocupadas que quedan entre la cama inicial y final. Sin embargo, intente no rebasar el 100% de la capacidad para conservar la congruencia del sistema.
            </div>
        </>
    )
}

export default IntruccionesSeleccionDeCamasV2;